/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 11:50 AM
 *
 */

import moment from 'moment';

export const epochToDate = (epochInSec: number) =>
  moment(epochInSec * 1000).format('MMMM Do, YYYY');
